import { useState, useEffect } from 'react'

const DEADLINE = new Date('2026-06-13T23:59:59')

function computeTimeLeft(deadline) {
  const diff = deadline - Date.now()
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true }
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    expired: false,
  }
}

function useCountdown(deadline) {
  const [timeLeft, setTimeLeft] = useState(() => computeTimeLeft(deadline))

  useEffect(() => {
    const id = setInterval(() => setTimeLeft(computeTimeLeft(deadline)), 1000)
    return () => clearInterval(id)
  }, [deadline])

  return timeLeft
}

function pad(n) {
  return String(n).padStart(2, '0')
}

export default function AnnouncementBar() {
  const [dismissed, setDismissed] = useState(false)
  const { days, hours, minutes, seconds, expired } = useCountdown(DEADLINE)

  if (dismissed || expired) return null

  return (
    <div
      className="relative z-[60] flex items-center justify-center gap-3 px-5 py-2.5 text-white text-[12px] sm:text-[13px] font-medium"
      style={{ background: '#0E0E0C' }}
    >
      {/* Pulse dot */}
      <span className="flex-shrink-0 relative flex items-center justify-center w-4 h-4">
        <span className="absolute inline-flex w-full h-full rounded-full bg-green-500 opacity-40 animate-ping" />
        <span className="relative w-2 h-2 rounded-full bg-green-400" />
      </span>

      {/* Text */}
      <span className="text-white/70">
        Vagas limitadas{' '}
        <span className="text-white font-semibold">
          trave R$149/mês para sempre.
        </span>
      </span>

      {/* Countdown */}
      <span className="hidden sm:inline-flex items-center gap-1 text-white/40 text-[11px] font-mono tabular-nums">
        <span className="text-white/60 font-bold">{pad(days)}d</span>
        <span>:</span>
        <span className="text-white/60 font-bold">{pad(hours)}h</span>
        <span>:</span>
        <span className="text-white/60 font-bold">{pad(minutes)}m</span>
        <span>:</span>
        <span className="text-white/60 font-bold">{pad(seconds)}s</span>
      </span>

      {/* CTA */}
      <a
        href="#precos"
        className="flex-shrink-0 hidden sm:inline-flex items-center gap-1 bg-white/10 hover:bg-white/18 border border-white/15 text-white no-underline px-3 py-1 rounded-full text-[11px] font-bold transition-colors"
      >
        Ver oferta
      </a>

      {/* Dismiss */}
      <button
        onClick={() => setDismissed(true)}
        className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-white/40 hover:text-white/80 transition-colors bg-transparent border-none cursor-pointer p-0"
        aria-label="Fechar"
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M1 1l10 10M11 1L1 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      </button>
    </div>
  )
}
